import ClassHelper from '../ClassHelper';

class OrderClient extends ClassHelper {
  constructor({ phone, firstName, lastName, middleName, fullName } = {}) {
    super(...arguments);
    this.phone = phone;
    this.firstName = firstName;
    this.lastName = lastName;
    this.middleName = middleName;
    this.fullName = fullName;
  }
}

export default OrderClient;